// Cspell:ignore sidetab

import { Sidetab } from "@typeform/embed-react";
import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { accountAtom } from "~/lib/account";
import { isString } from "~/lib/utils";
import type { articleTypeformArticle$key } from "~/queries/__generated__/articleTypeformArticle.graphql";

import { useIsShowTypeform } from "./hooks";

type Props = {
  reference: articleTypeformArticle$key;
};

export const ArticleTypeform: FunctionComponent<Props> = ({ reference }) => {
  const article = useFragment(
    graphql`
      fragment articleTypeformArticle on Article {
        entityId
        ...hooksIsShowTypeformArticle
      }
    `,
    reference,
  );

  const { user } = useAtomValue(accountAtom);
  const { query } = useRouter();
  const { isShowTypeform } = useIsShowTypeform(article);

  const renderValue = (value: string | string[] | undefined) => {
    if (Array.isArray(value)) {
      return value.join(", ");
    } else if (isString(value)) {
      return value;
    } else {
      return "";
    }
  };
  if (!isShowTypeform) return;

  return (
    <Sidetab
      buttonColor="#FFCB05"
      buttonText="Rate this article"
      hidden={{
        utm_campaign: renderValue(query?.utm_campaign),
        utm_content: article.entityId,
        utm_medium: renderValue(query?.utm_medium),
        utm_source: user?.uuid ?? "",
        utm_term: renderValue(query?.utm_term),
      }}
      id="B2vUPaTF"
      medium="snippet"
      opacity={100}
      hideHeaders
      transitiveSearchParams
    />
  );
};

ArticleTypeform.displayName = "ArticleTypeform";
